import React from 'react';
import { FieldType } from './field.types';
import { EventRegistrationFormFieldOptions } from '../generated/api/dsv-public/model';
import { Box } from '@mui/material';

type SpaceFieldProps = FieldType & {
  options: EventRegistrationFormFieldOptions;
};

export const SpaceField: React.FC<SpaceFieldProps> = ({ fieldKey, options }) => {
  return <Box className="field-spacer" key={fieldKey} sx={{ my: parseInt(options.height) }}></Box>;
};
